import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';
import __vue_component__ from '../SdsButton/SdsButton.vue.js';
import { sanitize } from '@superbet-group/web.lib.vue-utilities';

var toggleButtonType = {
    ShowMore: 'ShowMore',
    ShowLess: 'ShowLess',
};
var script = defineComponent({
    name: 'SeoCopyBlock',
    props: {
        seoCopy: {
            type: String,
            required: true,
        },
    },
    setup: function (props) {
        var toggleButtonTypeValue = ref(toggleButtonType.ShowMore);
        var isOverflowing = ref(false);
        var seoContentElement = ref(null);
        var checkOverflow = function () {
            var _a, _b;
            if (((_b = (_a = seoContentElement === null || seoContentElement === void 0 ? void 0 : seoContentElement.value) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0) > 180) {
                isOverflowing.value = true;
            }
            else {
                isOverflowing.value = false;
            }
        };
        var sanitizedCopy = computed(function () {
            return sanitize(props.seoCopy, {
                onlyAllowedTags: ['p', 'h2', 'h3', 'h4', 'ol', 'ul', 'li', 'a', 'strong', 'em', 'u', 'blockquote'],
                onlyAllowedAttributes: ['href'],
            });
        });
        onMounted(function () {
            checkOverflow();
        });
        var onToggleButtonClick = function () {
            if (toggleButtonTypeValue.value === toggleButtonType.ShowMore) {
                toggleButtonTypeValue.value = toggleButtonType.ShowLess;
            }
            else {
                toggleButtonTypeValue.value = toggleButtonType.ShowMore;
            }
        };
        return {
            onToggleButtonClick: onToggleButtonClick,
            sanitizedCopy: sanitizedCopy,
            seoContentElement: seoContentElement,
            isOverflowing: isOverflowing,
            toggleButtonText: computed(function () {
                return toggleButtonTypeValue.value === toggleButtonType.ShowMore ? 'show more' : 'show less';
            }),
            isExpanded: computed(function () {
                return toggleButtonTypeValue.value === toggleButtonType.ShowLess;
            }),
        };
    },
    components: {
        SdsButton: __vue_component__,
    },
});

export default script;
